import { render } from "./index.vue?vue&type=template&id=3d8968be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3d8968be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8968be"],['__file',"src/components/RichTextView/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d8968be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d8968be', __exports__)) {
    api.reload('3d8968be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3d8968be&scoped=true", () => {
    api.rerender('3d8968be', render)
  })

}


export default __exports__